import { withNamespaces } from "react-i18next";
import { Card, CardBody, CardTitle } from "reactstrap";
import { VectorMap } from "react-jvectormap";
import { useQuery } from "@tanstack/react-query";
import ComplianceMonitoringDashboardService from "src/modules/3rd-party-management/apis/admin/compliance/monitoring/DashboardService";
import { toast } from "react-toastify";
import ChartError from "src/modules/3rd-party-management/pages/admin/compliance/components/dashboard/ChartError";

const RisksHeatmap = ({ t, filters }) => {
    const fetchDataQuery = useQuery({
        queryKey: [
            "3rd-party-management-fetch-compliance-monitoring-dashboard",
            "heatmap",
            filters
        ],
        queryFn: async () => {
            const service = ComplianceMonitoringDashboardService.getInstance();

            return await service.fetchHeatmapData(filters);
        },
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t("An error occurred while fetching dashboard data."), {
                type: "error"
            });
        }
    });

    if (fetchDataQuery.isFetching) {
        return (
            <Card>
                <CardBody>
                    <div className="dt-field dt-skeleton mb-2" style={{ width: '40%' }}></div>
                    <div className="dt-field dt-skeleton" style={{ width: '100%', height: '320px' }}></div>
                </CardBody>
            </Card>
        );
    }

    const {
        allCountries = {},
        rating = []
    } = fetchDataQuery.data || {};

    const renderVectorMap = () => {
        const result = {};

        for (const cKey in allCountries) {
            result[cKey] = `#${allCountries[cKey]?.color}`;
        }

        return (
            <VectorMap
                map={"world_mill"}
                backgroundColor="transparent"
                zoomOnScroll={false}
                onRegionTipShow={(e, el, code) => {
                    el.text(t(el.text()) + " (" + allCountries[code]?.amount + ")");
                }}
                onRegionOut={(e, code) => {
                    Array.from(document.getElementsByClassName("jvectormap-tip")).forEach((el) => {
                        el.style.display = "none";
                    });
                }}
                containerClassName="map"
                regionStyle={{
                    initial: {
                        fill: "#e4e4e4",
                        "fill-opacity": 0.9,
                        stroke: "none",
                        "stroke-width": 0,
                        "stroke-opacity": 0,
                        cursor: "pointer"
                    },
                    hover: {
                        "fill-opacity": 0.8,
                        cursor: "pointer"
                    },
                    selected: {
                        fill: "#212121",
                        stroke: "#d1d1d1",
                        "stroke-width": 1
                    },
                    selectedHover: {
                        "fill-opacity": 0.8
                    }
                }}
                regionsSelectable={false}
                series={{
                    regions: [
                        {
                            values: result,
                            normalizeFunction: "polynomial"
                        }
                    ]
                }}
            />
        )
    }

    return (
        <Card>
            <CardBody>
                <div className="mb-4">
                    <CardTitle>
                        {t("Risk Heatmap")}
                    </CardTitle>
                </div>
                {fetchDataQuery.isError ? (
                    <ChartError
                        title={
                            fetchDataQuery.error?.response?.status === 403 ?
                                'Error 403' :
                                null
                        }
                        message={
                            fetchDataQuery.error?.response?.status === 403 ?
                                'Please upgrade your plan to access this feature' :
                                null
                        }
                        onRetry={fetchDataQuery.refetch}
                    />
                ) : (
                    <>
                        <div>
                            {renderVectorMap()}
                        </div>
                        <div className="d-flex justify-content-center mt-5">
                            {(rating || []).map((rating) => {
                                return (
                                    <div class="text-center ml-4">
                                        <p class="mb-2 text-truncate">
                                            <i class="mdi mdi-circle font-size-20 me-1" style={{
                                                color: `#${rating?.color}`
                                            }}></i>
                                            {t(rating?.long_name)}
                                        </p>
                                    </div>
                                )
                            })}
                        </div>
                    </>
                )}
            </CardBody>
        </Card>
    )
}

export default withNamespaces()(
    RisksHeatmap
);